import { Button, Modal, ThemeProvider } from '@alphonsocode/kallos';
import React from 'react';
import AdsureModalBody from './adsureModalBody';
import { track } from 'analytics/posthog';

function OnDemandButton() {
  const [onDemandModal, setOnDemandModal] = React.useState(false);

  React.useEffect(() => {
    if (!onDemandModal) return;
    track('adsure ondemand modal opened', {
      surface: 'adsure',
    });
  }, [onDemandModal]);
  return (
    <ThemeProvider defaultMode="light">
      <div
        className="modalDiv d-flex flex-column"
        style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}
      >
        <label
          style={{
            display: 'block',
            height: '15px',
            lineHeight: '15px',
            marginTop: 0,
            marginBottom: '4px',
            marginLeft: '2px',
          }}
          className="heading"
        >
          &nbsp;
        </label>
        <Button
          className="filterButton"
          colorVariant="deepGreen"
          variant="rounded"
          disableHoverEffect={true}
          onClick={() => setOnDemandModal(true)}
          style={{
            height: '35px',
            minHeight: '35px',
            marginRight: '10px',
            padding: '7px 14px',
            borderRadius: '5px',
            fontSize: '13px',
            lineHeight: '18px',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxSizing: 'border-box',
            whiteSpace: 'nowrap',
            width: 'auto',
          }}
        >
          Create On Demand Test
        </Button>
      </div>
      <div>
        <Modal.Root open={onDemandModal}>
          <Modal.Overlay />
          <Modal.Dialog
            style={{
              width: '1069px',
              height: '77%',
              display: 'flex',
              flexDirection: 'column',
              maxHeight: '77vh',
            }}
          >
            <>
              <Modal.Header
                closeButton={true}
                onClick={() => setOnDemandModal(false)}
              >
                <Modal.Title style={{ fontSize: '15px', color: '#0F215F' }}>
                  Manual Creative Setup
                </Modal.Title>
              </Modal.Header>
              <div
                style={{
                  flex: 1,
                  overflow: 'auto',
                  minHeight: 0,
                }}
              >
                <AdsureModalBody
                  deviceId={null}
                  setOnDemandModal={setOnDemandModal}
                  setOnDemandTest={() => {}}
                />
              </div>
            </>
          </Modal.Dialog>
        </Modal.Root>
      </div>
    </ThemeProvider>
  );
}

export default OnDemandButton;
